import { Stack, styled } from '@mui/material'

export const ButtonsContainer = styled(Stack, { name: 'ButtonsContainer' })({
  flexDirection: 'row',
  width: '100%',
  '& > * + *': {
    marginLeft: '8px',
  },
})
